import $ from 'jquery';
import throttle from 'lodash/throttle';

class BottomBar {
    constructor(options) {
        let defaults = {
            $bar: null,
            $hideTrigger: $('.footer'),
            $showTrigger: null,
            $showTriggerEnd: null,
            triggerPositionFraction: null,
            mobile: false
        };

        this.options = $.extend({}, defaults, options);

        this.$win = $(window);
        this.$body = $('body');
        this.$bottomBar = this.options.$bar;

        this.pos = window.pageYOffset || document.documentElement.scrollTop;

        this.events();
    }

    events() {
        this.$body.on('font-size-change', this.init.bind(this));
        $('window').on('load', this.init.bind(this));

        this.handleScroll = throttle(this.options.mobile ? this.toggleBarOnlyDown.bind(this) : this.toggleBar.bind(this), 100);

        window.addEventListener('scroll', this.handleScroll, {passive: true});

        this.$bottomBar.on('click', '.close', e => {
            e.preventDefault();
            this.$bottomBar.removeClass('bar-in');
            window.removeEventListener('scroll', this.handleScroll, {passive: true});
        });

        this.$win.scroll();
    }

    init() {
        let winH = this.$win.height();

        if (this.options.triggerPositionFraction) {
            this.triggerPosition = $(document).height() * this.options.triggerPositionFraction;
        } else if (this.options.$showTrigger && this.options.$showTrigger.length) {
            this.triggerPosition = this.options.$showTrigger.offset().top - winH;
        } else if (this.options.$showTriggerEnd && this.options.$showTriggerEnd.length) {
            this.triggerPosition = this.options.$showTriggerEnd.offset().top + this.options.$showTriggerEnd.height();
        }
        this.articleEnd = this.options.$hideTrigger.offset().top - winH;
    }

    toggleBar() {
        this.pos = window.pageYOffset || document.documentElement.scrollTop;

        if (this.pos >= this.triggerPosition) {
            this.$bottomBar.addClass('bar-in');

            if (this.pos >= this.articleEnd) {
                this.$bottomBar.removeClass('bar-in');
            }
        } else {
            this.$bottomBar.removeClass('bar-in');
        }
    }

    toggleBarOnlyDown() {
        let prevPos = this.pos;

        this.toggleBar();

        this.$bottomBar.toggleClass('bar-unpinned', this.pos - prevPos <= 0);
    }
}

export default BottomBar;



// WEBPACK FOOTER //
// ./sources/js/components/bottom-bar.js